import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PayrollService } from 'app/services/models/payroll.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss']
})
export class PayrollComponent implements OnInit {
  @Input() data: { personId: number; row: any };
  payrollForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private payrollService: PayrollService,
    private fb: FormBuilder,
    private toastrService: ToastrService) { }

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  ngOnInit(): void {
    this.payrollForm = this.fb.group({
      personId: [this.data.personId, [Validators.required]],
      salaryPaymentDate: [null, [Validators.required]],
      fM2Hours: [0],
      fM3Hours: [0],
      fmTotalEarnings: [0],
      eK2Earnings: [0],
      transportationAllowance: [0],
      totalDays: [0],
      sickLeaveDays: [0],
      paidDays: [0],
      unpaidDays: [0],
      annualLeaveDays: [0],
      monthlyNetPaid: [0],
      garnishmentDeduction: [0],
      advanceDeduction: [0],
      besContribution: [0],
      netAfterBes: [0],
      grossSalary:[0]
    });

    if (this.data.row) {
      this.payrollForm.patchValue({
        ...this.data.row,
        personId: this.data.personId
      });
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.payrollForm.valid) {
      const payload = this.payrollForm.value;
      if (payload.salaryPaymentDate && payload.salaryPaymentDate instanceof Array) {
        payload.salaryPaymentDate = payload.salaryPaymentDate[0];
      }
      console.log(payload);
      let response;
      if (this.data.row) {
        response = await this.payrollService.updatePayroll(this.data.row.id, payload);
      } else {
        response = await this.payrollService.createPayroll(payload);
      }

      if (response.status === true) {
        this.payrollService.sendEvent(true);
        this.closeModal();
        this.toastrService.success(response.message);
      } else {
        this.toastrService.error(response.message);
      }
    }
  }
}
